<template>
    <b-card no-body class="p-4 shadowed d-block"> <!-- d-block just to fix bug of image with IE11 -->
        <b-row no-gutters>
            <b-col md="4" class="d-flex justify-content-center">
                <b-skeleton-img animation="fade" :height="isMobile ? '140px' : '210px'" :width="isMobile ? '190px' : '100%'" no-aspect />
            </b-col>
            <b-col md="8" class="d-flex flex-column justify-content-between mt-3 mt-md-0">
                <b-card-body>
                    <b-skeleton animation="fade" height="19px" width="175px" class="mb-3" />
                    <b-skeleton animation="fade" height="14px" width="100%" />
                    <b-skeleton animation="fade" height="14px" width="100%" v-if="isMobile" />
                    <b-skeleton animation="fade" height="14px" :width="isMobile ? '100%' : '200px'" />
                    <b-skeleton type="button" animation="fade" class="mt-3 mt-md-auto ml-auto" />
                </b-card-body>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
    import mobileCheckMixin from "../../mixins/mobileCheckMixin";

    export default {
        name: "ServiceListSkeleton",
        mixins: [mobileCheckMixin]
    }
</script>